import React from 'react';
import { AlertCircle, Check, ChevronDown, Circle, Loader2 } from 'lucide-react';
import { cn } from 'lib/utils';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from 'components/ui/collapsible';

const ICONS = {
  done: <Check size={14} className="text-success" />,
  running: <Loader2 size={14} className="animate-spin text-primary" />,
  failed: <AlertCircle size={14} className="text-destructive" />,
  attention: <AlertCircle size={14} className="text-warning" />,
  idle: <Circle size={14} className="text-muted-foreground" />,
};

export default function StageCard({ n, title, status = 'idle', summary, open, onOpenChange, children, disabled }) {
  return (
    <Collapsible open={open} onOpenChange={onOpenChange} className="rounded-token-large border border-borderGrey bg-white">
      <CollapsibleTrigger
        disabled={disabled}
        className={cn(
          'flex w-full items-center gap-3 px-4 py-3 text-left',
          disabled ? 'cursor-not-allowed opacity-60' : 'hover:bg-muted/40'
        )}
      >
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-token-base font-medium">
          {n}
        </span>
        <span className="flex-1">
          <span className="flex items-center gap-2 text-token-md font-medium">
            {title} {ICONS[status]}
          </span>
          {summary && <span className="block text-token-base text-muted-foreground">{summary}</span>}
        </span>
        <ChevronDown size={16} className={cn('transition-transform', open && 'rotate-180')} />
      </CollapsibleTrigger>
      <CollapsibleContent className="border-t border-borderGrey px-4 py-4">{children}</CollapsibleContent>
    </Collapsible>
  );
}
